export default __webpack_public_path__ + "static/media/1891023_cancel_cercle_close_delete_dismiss_icon.2321b5e8.png";